import { render, staticRenderFns } from "./AdFeed.vue?vue&type=template&id=cc923dbe&scoped=true&"
import script from "./AdFeed.vue?vue&type=script&lang=ts&"
export * from "./AdFeed.vue?vue&type=script&lang=ts&"
import style0 from "./AdFeed.vue?vue&type=style&index=0&id=cc923dbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc923dbe",
  null
  
)

export default component.exports